export default __webpack_public_path__ + "static/media/100-200.f52e6def.jpg";